import React from "react";
import { Box } from "@singlestore/fusion/components/layout";

import "./Table.scss";

export function Table({ children }: React.PropsWithChildren) {
    return (
        <Box mb="4x">
            <table className="table-component">{children}</table>
        </Box>
    );
}
